import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class CreateRichDocumentCommandHandler implements IPlatformCommandHandler {
  constructor(
    private dialogService: DialogService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.dialogService.showTextInputDialog('Document Title', '')
      .pipe(take(1))
      .subscribe(state => {
        console.log(state);
        if (state.action === 'OK') {
          command.fieldValues['DocumentTitle'] = state.data.input.text;
          handler.executeCommand(command);
        }
      });
    return true;
  }
}
